import addItemIdToFilter from "./addItemToFilter";
import getPeriodeEndDate from "./getPeriodeEndDate";
import getMomentDateObj from "./getMomentDateObj";
import setMomentDateObjZero from "./setMomentDateObjZero";
import getMomentNow from "./getMomentNow";
import getMomentTomorrow from './getMomentTomorrow'
import getDateIntervall from "./getDateIntervall";
import getDayKey from "./getDayKey";
import moment from "moment";

const getItemsByFilter = (itemsData, moviesOrder, routesData, globalAttributes = '', hideTheatres, translation, hiddenAttributes, showSeatClassesArray) => {
    const { timezone, locale } = translation
    const today = getMomentNow( translation.timezone)
    const todayZero = setMomentDateObjZero(today.clone())
    const tomorrowZero = setMomentDateObjZero(getMomentTomorrow(today))
    const endDate = getPeriodeEndDate(today, 6)
    const weekPeriode = getDateIntervall(todayZero, endDate)
    let filterToday = {}
    let filterTomorrow = {}
    let filterWeek = {}
    let filterAll = {}
    let filterTitles = {}
    let filterWeekDays = {}

    const weekArray = moment.localeData(locale).weekdaysShort(true)
    const weekArrayLong = moment.localeData(locale).weekdays(true)

    weekArrayLong.map((day, index) => {
        filterWeekDays[day.toLowerCase()] = {
            displayName: weekArray[index],
            items: [],
            performances: []
        }
    })

    moviesOrder.map(itemId => {
        const item = itemsData[itemId]
        const { title, performances } = item

        if(performances) {
            _.keys(performances).map(perfId => {
                const performance = performances[perfId]
                const { timeUtc } = performance
                
                if(timeUtc) {
                    const momentPerfDate = getMomentDateObj(timeUtc, timezone)
                    const momentPerfDateZero = setMomentDateObjZero(momentPerfDate.clone())
                    const momentPerfWeekDayNumber = momentPerfDateZero.weekday()
                    const momentPerfWeekDay = weekArrayLong[momentPerfWeekDayNumber].toLowerCase()

                    if(todayZero.isSame(momentPerfDateZero) && today.isSameOrBefore(momentPerfDate)) {
                        filterToday = addItemIdToFilter(filterToday, 'items', itemId)
                        filterToday = addItemIdToFilter(filterToday, 'performances', performance.id)
                    }

                    if(tomorrowZero.isSame(momentPerfDateZero)) {
                        filterTomorrow = addItemIdToFilter(filterTomorrow, 'items', itemId)
                        filterTomorrow = addItemIdToFilter(filterTomorrow, 'performances', performance.id)
                    }

                    if(weekPeriode.hasOwnProperty(getDayKey(momentPerfDate)) && today.isSameOrBefore(momentPerfDate)) {
                        filterWeek = addItemIdToFilter(filterWeek, 'items', itemId)
                        filterWeek = addItemIdToFilter(filterWeek, 'performances', performance.id)
                    }
                    
                    if(_.contains(_.keys(filterWeekDays), momentPerfWeekDay) && today.isSameOrBefore(momentPerfDate)) {
                        filterWeekDays[momentPerfWeekDay] = addItemIdToFilter(filterWeekDays[momentPerfWeekDay], 'items', itemId)
                        filterWeekDays[momentPerfWeekDay] = addItemIdToFilter(filterWeekDays[momentPerfWeekDay], 'performances', performance.id)
                    }

                    
                }

                filterAll = addItemIdToFilter(filterAll, 'performances', performance.id)
            })
        }

        if(title && routesData && routesData.movies.items.hasOwnProperty(itemId))  {
            const uri_path = routesData.movies.items[itemId].uri_path

            filterTitles = addItemIdToFilter(filterTitles, uri_path, itemId)
        }
    })
        
    if(globalAttributes === '') {
        return {
            filters: {},
            dayFilters: {
                today: {
                    displayName: translation.strings.todayFilter,
                    items: filterToday.items,
                    performances: filterToday.performances
                },
                tomorrow: {
                    displayName: translation.strings.tomorrowFilter,
                    items: filterTomorrow.items,
                    performances: filterTomorrow.performances
                },
                week: {
                    displayName: translation.strings.weekFilter,
                    items: filterWeek.items,
                    performances: filterWeek.performances
                },
                all: {
                    displayName: translation.strings.allFilter,
                    items: filterAll.items,
                    performances: filterAll.performances
                },
                filterWeekDays: filterWeekDays
            }
        }
    } else {
        if(hiddenAttributes) {
            hiddenAttributes.map(attr => {
                if(_.contains(_.keys(globalAttributes.technical), attr)) {
                    delete globalAttributes.technical[attr];
                }
            })
        }
        
        let visibleSeatClassesObj = {}

        if(showSeatClassesArray && globalAttributes.seatClasses) {
            showSeatClassesArray.map(seatClass => {
                visibleSeatClassesObj[seatClass] = globalAttributes.seatClasses[seatClass]
            })    
        }

        _.keys(globalAttributes.seatClasses).map(seatClassesDataKey => {
            let seatClassesData = globalAttributes.seatClasses[seatClassesDataKey]
            let seatClassesPerformances = []

            if(seatClassesData) {
                const {movies} = seatClassesData
                
                movies.map(itemId => {
                    const item = itemsData[itemId]
                    if(!item) {
                        return ''
                    }

                    const { performances } = item
                    
                    if(performances) {
                        _.keys(performances).map(perfId => {
                            const performance = performances[perfId]
                            const {seatClasses} = performance

                            const performanceHasAttribute = _.find(seatClasses, seatClass => {
                                return seatClass.id === seatClassesDataKey
                            }) 

                            if(performanceHasAttribute) {
                                if(!_.contains(seatClassesPerformances, performance.id)) {
                                    seatClassesPerformances.push(performance.id)
                                }
                            }   
                        })
                    }
                })
            }
            
            seatClassesData["performances"] = seatClassesPerformances
        })

        _.keys(globalAttributes.theatres).map(theatreDataKey => {
            let theatreData = globalAttributes.theatres[theatreDataKey]
            let theatrePerformances = []

            if(theatreData) {
                const {movies} = theatreData
                
                movies.map(itemId => {
                    const item = itemsData[itemId]
                    if(!item) {
                        return ''
                    }

                    const { performances } = item
                    
                    if(performances) {
                        _.keys(performances).map(perfId => {
                            const performance = performances[perfId]
                            const {theatreID} = performance
                            
                            if(theatreDataKey === theatreID) {
                                if(!_.contains(theatrePerformances, performance.id)) {
                                    theatrePerformances.push(performance.id)
                                }
                            }
                        })
                    }
                })
            }
            
            theatreData["performances"] = theatrePerformances
        })
       
        _.keys(globalAttributes.technical).map(technicalDataKey => {
            let technicalData = globalAttributes.technical[technicalDataKey]
            let technicalPerformances = []

            if(technicalData) {
                const {movies} = technicalData
                
                movies.map(itemId => {
                    const item = itemsData[itemId]
                    if(!item) {
                        return ''
                    }
                    
                    const { performances } = item
                    
                    if(performances) {
                        _.keys(performances).map(perfId => {
                            const performance = performances[perfId]
                            const {attributes} = performance
                            const performanceHasAttribute = _.find(attributes, attribute => {
                                return attribute.id === technicalDataKey
                            }) 
                            
                            if(performanceHasAttribute) {
                                if(!_.contains(technicalPerformances, performance.id)) {
                                    technicalPerformances.push(performance.id)
                                }
                            }
                        })
                    }
                })
            }

            technicalData["performances"] = technicalPerformances
        })

        console.log(hideTheatres || hideTheatres === 'true', hideTheatres)

        return {
            filters: {
                genres: {
                    displayName: translation.strings.genresFilter,
                    items:  globalAttributes.genres
                }, 
                technical: {
                    displayName: translation.strings.technicalFilter,
                    items:  globalAttributes.technical
                },
                fsk: {
                    displayName: translation.strings.fskFilter,
                    items:  globalAttributes.fsk,
                },
                theatreName: {
                    displayName: translation.strings.theatreName,
                    items: (hideTheatres || hideTheatres === 'true') ? [] : globalAttributes.theatres
                },
                seatClasses: {
                    displayName: translation.strings.seatClassesName,
                    items: visibleSeatClassesObj 
                },
            },
            searchFilter: {
                items: [],
            },
            dayFilters: {
                today: {
                    displayName: translation.strings.todayFilter,
                    items: filterToday.items,
                    performances: filterToday.performances
                },
                tomorrow: {
                    displayName: translation.strings.tomorrowFilter,
                    items: filterTomorrow.items,
                    performances: filterTomorrow.performances
                },
                week: {
                    displayName: translation.strings.weekFilter,
                    items: filterWeek.items,
                    performances: filterWeek.performances
                },
                all: {
                    displayName: translation.strings.allFiltersShort,
                    items: filterAll.items,
                    performances: filterAll.performances
                },
                filterWeekDays: filterWeekDays
            },
            titleFilter: {
                items: filterTitles
            }
        }
    }
    
}

export default getItemsByFilter